module.exports = __webpack_public_path__ + "img/hohlsaum_kieferngruen_ral6028.791d5129.jpg";